<ion-row>
  <ion-col class="violation" size="5">
    <ion-button class="ion-text-left" (click)="overrule.emit(sideNumber)" expand="block" fill="clear">
      Overrules: <ion-icon *ngFor="let item of overrules" style="padding: 2px;" color="light" name="close-circle"></ion-icon>
    </ion-button>
  </ion-col>

  <ion-col class="violation" (click)="time.emit(sideNumber)">
    <ion-button expand="block" fill="clear">
      Time
    </ion-button>
  </ion-col>

  <ion-col class="violation" (click)="break.emit(sideNumber)">
    <ion-button expand="block" fill="clear">
      Break
    </ion-button>
  </ion-col>

  <ion-col class="violation" (click)="code.emit(sideNumber)">
    <ion-button expand="block" fill="clear">
      Code
    </ion-button>
  </ion-col>

</ion-row>